<template>
  <div class="no-data">
    <img src="@/assets/delivery/icon-empty.png" alt="icon-empty.png" />
    <p>{{text}}</p>
  </div>
</template>

<script>
  export default {
    name: 'NoData',
    props: {
      text: {
        type: String,
        default: '您的待产包暂无完成的内容～～'
      }
    }
  }
</script>

<style lang="scss">
  @import "../../Eating/styles/index.scss";
  .no-data {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-size: pxTOvw(34px);
    color: #666;
    margin-top: pxTOvw(90px);
    img {
      width: pxTOvw(265px);
    }
    p {
      margin-top: pxTOvw(20px);
    }
  }
</style>
